export const ModeloDocumento = [
    {key:55, text:'NF-e'},
    {key:65, text:'NFC-e'},
    {key:58, text:'MDF-e'}
]